"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMPTY_INSTRUCTION = void 0;
exports.EMPTY_INSTRUCTION = {
  instructions: [],
  cleanupInstructions: [],
  signers: []
};
//# sourceMappingURL=types.js.map